import React, { useState } from 'react';
import { ButtonUI, DeleteDialogUI, DialogUI, FileTabUI, FileUploadUI } from '../Interface';
import { Box } from '@mui/material';
import productionService from '../../service/production.service';
import useUsers from '../../context/UsersContext';

const ReportAttachmentDialog = ({ dialogData, handleClose, setRefetchTable }) => {
  const { user } = useUsers();
  const { open, attachments, productionId, productionReportId } = dialogData;
  const [filesToUpload, setFilesToUpload] = useState([]);

  const handleUpload = () => {
    const formData = new FormData();

    for (const file of filesToUpload) {
      formData.append('files', file.file);
    }

    productionService.uploadProductionAttachments(formData, productionId, user.userId, productionReportId).then(() => {
      setFilesToUpload([]);
      setRefetchTable(true);
      handleClose();
    });
  };

  const handleFilesChange = (newFiles) => {
    setFilesToUpload(newFiles);
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <FileUploadUI onFilesChange={handleFilesChange} />
      <Box mt="1rem">
        <FileTabUI savedFiles={attachments ?? []} />
      </Box>
      <Box display="flex" gap={3} justifyContent="center" mt="1rem">
        <ButtonUI
          text="Feltöltés"
          className="bg-success flex gap-2 items-center"
          type="button"
          disabled={!filesToUpload?.length > 0}
          onClick={handleUpload}
        />
        <ButtonUI
          text="Mégse"
          className="bg-danger flex items-center gap-2"
          type="button"
          onClick={() => handleClose()}
        >
          Bezárás
        </ButtonUI>
      </Box>
    </DialogUI>
  );
};

export default ReportAttachmentDialog;
